"use client";

import Link from "next/link";

interface Category {
  id: string;
  name: string;
  slug: string;
}

interface MoreCategoriesProps {
  categories: Category[];
  currentCategoryId?: string;
}

export function MoreCategories({ categories, currentCategoryId }: MoreCategoriesProps) {
  // Filtrer la catégorie actuelle
  const otherCategories = categories.filter((cat) => cat.id !== currentCategoryId);

  if (otherCategories.length === 0) {
    return null;
  }

  return (
    <section className="py-10 max-w-[1180px] mx-auto">
      <h2 className="text-xl font-bold text-center mb-6">Plus de catégories</h2>
      <div className="flex flex-wrap justify-center gap-3">
        {otherCategories.map((category) => (
          <Link
            key={category.id}
            href={`/categories/${category.slug}`}
            className="px-4 py-2 border-2 border-secondary text-secondary rounded-full text-sm font-semibold uppercase tracking-wide hover:bg-secondary hover:text-white transition-colors"
          >
            {category.name}
          </Link>
        ))}
      </div>
    </section>
  );
}
